import { useCallback, useMemo, useState } from 'react';

type Filter = {
  selectedProviders?: string[];
  selectedTags?: string[];
};

export const useBillingFilter = (data) => {
  const [filter, setFilter] = useState<Filter>({
    selectedProviders: [],
    selectedTags: [],
  });

  const filteredData = useMemo(() => {
    return data.filter((row) => {
      const matchProviders =
        filter.selectedProviders.length === 0 ||
        filter.selectedProviders.includes(row.siteProvider.id);

      const matchTags =
        filter.selectedTags === undefined ||
        filter?.selectedTags?.length === 0 ||
        row.tags
          ?.map((t) => t.name)
          .some((tag) => filter.selectedTags.includes(tag));

      return matchProviders && matchTags;
    });
  }, [data, filter]);

  const handleFilter = useCallback(({ selectedProviders, selectedTags }) => {
    setFilter({
      selectedProviders,
      selectedTags,
    });
  }, []);

  return { filteredData, handleFilter };
};
